export default __webpack_public_path__ + "static/media/cancel-white.5fabba83.svg";